// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z1wf","content":"styles_content__2zl0N","tableWrap":"styles_tableWrap__17AS5"};